import React from "react";
import PropTypes from "prop-types";
import i18n from "i18next";

import ConfirmMain from "@/react-components/Confirm/Main";
import ConfirmCheckbox from "@/react-components/Confirm/Checkbox";
import ConfirmButton from "@/react-components/Confirm/Button";

class ConfirmBody extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checkboxDisabled: true,
      buttonDisabled: true,
    };
  }

  read = () => {
    const { showCheckbox, showConfirmButton } = this.props;
    if (showCheckbox) {
      const { checkboxDisabled } = this.state;
      checkboxDisabled && this.setState({ checkboxDisabled: false });
    } else if (showConfirmButton) {
      const { buttonDisabled } = this.state;
      buttonDisabled && this.setState({ buttonDisabled: false });
    }
  };

  check = (checked) => {
    this.setState({ buttonDisabled: !checked });
  };

  render() {
    const {
      header,
      title,
      date,
      content,
      showCheckbox,
      checkboxText,
      showConfirmButton,
      showCloseButton,
      confirmButtonText,
      closeButtonText,
      onClick,
      onClose,
      className,
      notNeedRead,
      // 課金-ADD-START
      downloadUrl,
      downloadText,
      // 課金-ADD-END
    } = this.props;
    const { checkboxDisabled, buttonDisabled } = this.state;
    return (
      <React.Fragment>
        {content ? (
          <div className={`confirm-body-container ${className || ""}`}>
            {header ? header : null}
            <div className="confirm-body-container-title">{title}</div>
            {/* 課金-UPD-START */}
            {date ? (
              <div
                className={`confirm-body-container-date${
                  downloadUrl ? " margin-bottom" : ""
                }`}
              >
                {date}
              </div>
            ) : null}
            {/* 課金-UPD-END */}
            {/* 課金-ADD-START */}
            {downloadUrl ? (
              <a
                className="confirm-body-container-download"
                target="_blank"
                rel="noopener noreferrer"
                href={downloadUrl}
              >
                <img src={require("@/assets/images/download.svg")} alt="" />
                <span
                  dangerouslySetInnerHTML={{
                    __html: downloadText || i18n.t("common_download_title"),
                  }}
                />
              </a>
            ) : null}
            {/* 課金-ADD-END */}
            <ConfirmMain content={content} onRead={this.read} />
            {showCheckbox ? (
              <ConfirmCheckbox
                className="confirm-body-container-checkbox"
                text={checkboxText}
                disabled={checkboxDisabled}
                onChange={this.check}
              />
            ) : null}
            {showConfirmButton || showCloseButton ? (
              <div className="confirm-body-container-button">
                {showCloseButton ? (
                  <ConfirmButton
                    className="confirm-body-container-button-close"
                    text={
                      closeButtonText || i18n.t("common_close_button_title")
                    }
                    onClick={() => onClose && onClose()}
                  />
                ) : null}
                {showConfirmButton ? (
                  <ConfirmButton
                    text={confirmButtonText}
                    disabled={buttonDisabled && !notNeedRead}
                    onClick={() => onClick && onClick()}
                  />
                ) : null}
              </div>
            ) : null}
          </div>
        ) : null}
      </React.Fragment>
    );
  }
}

ConfirmBody.propTypes = {
  title: PropTypes.string,
  date: PropTypes.string,
  content: PropTypes.string,
  header: PropTypes.element,
  showCheckbox: PropTypes.bool,
  checkboxText: PropTypes.string,
  showConfirmButton: PropTypes.bool,
  confirmButtonText: PropTypes.string,
  onClick: PropTypes.func,
  showCloseButton: PropTypes.bool,
  closeButtonText: PropTypes.string,
  onClose: PropTypes.func,
  notNeedRead: PropTypes.bool,
  // 課金-ADD-START
  downloadText: PropTypes.string,
  downloadUrl: PropTypes.string,
  // 課金-ADD-END
};

ConfirmBody.defaultProps = {
  showCheckbox: true,
  showConfirmButton: true,
  showCloseButton: false,
};

export default ConfirmBody;
